// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__3fYDM","row":"styles_row__2ZbH7"};